import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
	{
		path: "/login",
		name: "login",
		component: () => import("./views/Login.vue"),
	},
	{
		path: "/projects",
		children: [
			{
				path: "",
				name: "projects",
				component: () => import("./views/Projects.vue"),
			},
			{
				path: ":project_id/events",
				name: "events",
				component: () => import("./views/Events.vue"),
				children: [
					{
						path: ":event_id/stats",
						name: "event-stats",
						component: () => import("./views/EventStats.vue"),
					},
					{
						path: ":event_id/live/:map_id?",
						name: "event-live",
						component: () => import("./views/EventLivePage.vue"),
					},
					{
						path: ":event_id/settings",
						name: "event-settings",
						component: () => import("./views/EventSettingsPage.vue"),
					},
				],
			},
		],
	},
	{
		path: "/",
		redirect: "/projects",
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

// Navigation guard to protect routes and handle auth
router.beforeEach((to, from, next) => {
	const loggedIn = !!localStorage.getItem('credentials' + window.VERSION);
	// Allow access to login page
	if (to.path === "/login") {
		// If already authenticated, redirect to projects
		if (!!loggedIn) {
			next("/projects");
		} else {
			next();
		}
		return;
	}

	// All other routes require authentication
	if (!loggedIn) {
		next("/login");
		return;
	}

	next();
});

export default router;
